import React, { useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { RootState } from "@/store/type";
import CategoriesList, { Category } from "./CategoriesListL";
// import useRegisterCompany from "@/hooks/use-register-company";
import useOffer from "@/hooks/useTender";
// import { CategoryOption } from "../../tender/tenders-mine-page";

export const MyCompanyPage: React.FC = () => {
  // const myCompany = useSelector((state: RootState) => state.auth.myCompany);
  const [categoris, setCategoris] = useState<Category[]>([]);
  const { getParentCategories } = useOffer();

  // useEffect(() => {
  //   if (myCompany?.categoriesIds) {
  //     setCategoriesId(myCompany.categoriesIds);
  //   }
  // }, [myCompany]);
  useEffect(() => {
    const fetchCategoris = async () => {
      try {
        const Categories = await getParentCategories();
        if (Categories) {
          setCategoris(Categories.data);
        }
      } catch (error) {
        console.error("Error fetching Offers:", error);
      }
    };
    fetchCategoris();
  }, []);
  // const { registerCompany } = useRegisterCompany();
  // const handleUpdateCategories = async (updatedCategories: string[]) => {
  //   setCategoriesId(updatedCategories);

  //   const updatedFormData = new FormData();
  //   updatedFormData.append("id", myCompany.id?.toString() || "");
  //   updatedFormData.append("nameAr", myCompany.nameAr);
  //   updatedFormData.append("nameEn", myCompany.nameEn);
  //   updatedFormData.append("website", myCompany.website);
  //   updatedFormData.append("address", myCompany.address);
  //   updatedFormData.append("region", myCompany.region);
  //   updatedFormData.append("city", myCompany.city);
  //   updatedFormData.append("registrationNumber", myCompany.registrationNumber);
  //   updatedFormData.append("ownerType", myCompany.ownerType);
  //   if (myCompany.stampedAuthorizationForm) {
  //     updatedFormData.append(
  //       "stampedAuthorizationForm",
  //       myCompany.stampedAuthorizationForm
  //     );
  //   }
  //   updatedFormData.append("plaseOfIssue", myCompany.plaseOfIssue);
  //   updatedFormData.append("turnover", myCompany.turnover.toString());
  //   updatedFormData.append("type", myCompany.type);
  //   updatedFormData.append("activities", myCompany.activities);
  //   updatedFormData.append("categoriesIds", JSON.stringify(updatedCategories));
  //   updatedFormData.append("contactInfo", myCompany.contactInfo);
  //   updatedFormData.append("creationDate", myCompany.creationDate);
  //   updatedFormData.append("expireDate", myCompany.expireDate);
  //   updatedFormData.append("CompanyNr", myCompany.CompanyNr);

  //   await registerCompany(updatedFormData);
  // };

  return (
    <div>
      <CategoriesList
      data={categoris}
        // categoriesId={categoriesId}
        // onUpdateCategories={handleUpdateCategories}
      />
    </div>
  );
};

export default MyCompanyPage;
